/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Stream type enum - mirrors avia-js StreamType exactly
 * @see {@link https://avia.cbsivideo.com/avia-js/latest/docs/api/player/enum/StreamType}
 */
export enum PlayerAdapterStreamType {
	VOD = 'VOD',
	LIVE = 'LIVE',
	LTS = 'DVR',
	DVR = 'DVR',
}